import React, { useState, useCallback } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';

function DeleteUser({ 
    titleText, 
    userEmail, 
    userName, 
    dataId, 
    wholesalerName, 
    wholesalerId,
    activeManageEmailPagin,
    closeDeleteUserPopup, 
    openManageEmailPopup 
}) {
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const handleResponse = (response) => {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
            return data;
        });
    };

    const cancelPopup = useCallback(() => {
        closeDeleteUserPopup();
        openManageEmailPopup(dataId, wholesalerId, wholesalerName, activeManageEmailPagin);
    }, [closeDeleteUserPopup, openManageEmailPopup, dataId, wholesalerId, wholesalerName, activeManageEmailPagin]);

    const deleteUser = useCallback(async () => {
        setError('');
        setLoading(true);

        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    UserEmail: userEmail, 
                    UserName: userName, 
                    UserId: dataId, 
                    WholeSaler: wholesalerName 
                })
            };
            
            const response = await fetch('/api/user/RemoveWholesalerAccount', requestOptions);
            const apidata = await handleResponse(response);
            
            if (apidata?.length > 0) {
                if (apidata[0].status_code === "1") {
                    setSuccessMessage(apidata[0].status_message);
                    setError('');
                    setLoading(false);
                    setTimeout(() => {
                        cancelPopup();
                    }, 1800);
                } else {
                    setError(apidata[0].status_message);
                    setSuccessMessage('');
                    setLoading(false);
                }
            } else {
                setError('Whoops, something went wrong. Please try again');
                setSuccessMessage('');
                setLoading(false);
            }
        } catch (err) {
            setError('Error');
            setLoading(false);
        }
    }, [userEmail, userName, dataId, wholesalerName, cancelPopup]);

    return (
        <Dialog open={true} onOpenChange={(open) => !open && cancelPopup()}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle>{titleText}</DialogTitle>
                </DialogHeader>
                
                {successMessage && (
                    <div className="p-3 rounded-md bg-green-50 text-green-700 text-sm border border-green-200">
                        {successMessage}
                    </div>
                )}

                {error && (
                    <div className="p-3 rounded-md bg-destructive/10 text-destructive text-sm">
                        {error}
                    </div>
                )}
                
                <DialogFooter className="gap-2 sm:gap-0">
                    <Button onClick={deleteUser} disabled={loading}>
                        {loading ? (
                            <>
                                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                                Deleting...
                            </>
                        ) : (
                            'Yes'
                        )}
                    </Button>
                    <Button variant="secondary" onClick={cancelPopup} disabled={loading}>
                        No
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

export default DeleteUser;